import { version } from "../../package.json"
import { version as livekitVersion } from 'livekit-client';

// set by vite-plugins/build-id.ts; missing in the tests
declare const __BUILD_ID__: string | undefined;
const buildId = typeof __BUILD_ID__ !== 'undefined' ? __BUILD_ID__ : 'dev';

export class Version {
    static EXTENSIONS = ""; // this is purely shown to the user.

    static OS_WINDOWS = 0;
    static OS_MAC_OSX = 1;
    static OS_HTML5 = 2;

    // initialize version strings
    static getVersionString() {
        let clientversion = version;

        if (Version.EXTENSIONS) {
            clientversion += "-" + Version.EXTENSIONS;
        }

        clientversion += (window.electron ? "-desktop" : "");

        return `${clientversion} (${livekitVersion}) build ${buildId}`;
    }

    static getVersionServerString() {
        const va = version.split('.');
        const major = Number.parseInt(va[0]);
        const minor = Number.parseInt(va[1]);
        const revision = Number.parseInt(va[2]);

        const minor4d = Intl.NumberFormat("EN", { minimumIntegerDigits: 4, useGrouping: false }).format(minor);
        const rev4d = Intl.NumberFormat("EN", { minimumIntegerDigits: 4, useGrouping: false }).format(revision);

        return `${major}${minor4d}${rev4d}`;

    }

    /**
     * The client version as one sortable number: 7.1.35 -> 700010035.
     * Used to compare the running version against the one a setting was
     * migrated for, see Config.migrate().
     */
    static getVersionNumber() {
        return Number.parseInt(Version.getVersionServerString(), 10);
    }

    static getVersionOS() {
        return "" + Version.OS_HTML5;
    }
}
